import type { PublicLanguage } from '@/entities/publicReport';

import type { PublicCopy } from '../copy';

export interface TranslationNoticeProps {
    /** De taal waarin de inhoud nu staat. */
    contentLanguage: PublicLanguage;
    /** De gekozen taal wordt nog vertaald, of dat lukte niet. */
    state: 'pending' | 'failed' | null;
    copy: PublicCopy;
}

/**
 * De regel onder de bedrijfsbalk van een rapport in een andere taal.
 *
 * - Vertaald: "Automatisch vertaald uit het Nederlands. De Nederlandse versie is
 *   leidend." - altijd, in de taal van de koper, want hij moet weten dat er een
 *   machine tussen zat.
 * - Terwijl de server vertaalt: dat het rapport wordt vertaald. Geen draaiend
 *   wieltje: de enige animatie in deze app is de sync-indicator.
 * - Lukte het niet: dat hij de Nederlandse versie leest. Rustig, geen rood: er
 *   is niets kapot, het rapport staat er gewoon.
 *
 * In het Nederlands, zonder vraag naar een andere taal, staat er niets.
 */
export function TranslationNotice({ contentLanguage, state, copy }: TranslationNoticeProps) {
    const text =
        state === 'pending'
            ? copy.translating
            : state === 'failed'
              ? copy.translationFailed
              : contentLanguage !== 'nl'
                ? copy.translationNotice
                : null;

    if (text === null) {
        return null;
    }

    return (
        <p
            role="status"
            className="m-0 border-b border-[var(--border-subtle)] bg-[var(--surface-subtle)] px-[var(--pr-pad-x)] py-[10px] text-[13px] leading-[18px] text-[var(--text-secondary)]"
        >
            {text}
        </p>
    );
}
